import { Pipe, PipeTransform } from '@angular/core';
import { CashOperationType } from '../../../../data/src/lib/entities/treasury.model';

const LABELS: Record<CashOperationType, string> = {
  [CashOperationType.Supply]: 'Reforço',
  [CashOperationType.Withdrawal]: 'Sangria',
  [CashOperationType.Adjustment]: 'Ajuste',
};

@Pipe({ name: 'cashOperationTypeLabel', standalone: true, pure: true })
export class CashOperationTypeLabelPipe implements PipeTransform {
  transform(value: CashOperationType): string {
    return LABELS[value];
  }
}
